import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import cn from "classnames";

import styles from "./AscTableResponsive.module.scss";
import { AdminChevronDownIcon } from "../AscIcons";

export function AscTableSorter({ index }: { index: string }) {
  const router = useRouter();
  const sortRef = useRef<HTMLSpanElement>(null);
  const sortBy = router.query.sortBy as string;
  const sortOrder = router.query.sortOrder as string;

  const handleClick = (str: string) =>
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          page: 1,
          sortBy: index,
          sortOrder: str,
        },
      },
      undefined,
      { shallow: true }
    );

  useEffect(() => {
    if (sortBy === index) {
      if (sortRef && sortRef.current) {
        sortRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }
  }, [sortBy, index]);

  return (
    <span ref={sortRef} className={styles.tableHeadSort}>
      {sortBy === index && sortOrder === "asc" ? (
        <AdminChevronDownIcon
          onClick={() => handleClick("desc")}
          className={cn(styles.icon, styles.iconRotate)}
        />
      ) : (
        <AdminChevronDownIcon
          onClick={() => handleClick("asc")}
          className={cn(styles.icon)}
        />
      )}
    </span>
  );
}
